import React, { useEffect, useReducer } from 'react';
import { useParams, useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Hidden from '@material-ui/core/Hidden';

import { getChallengeById } from '../../../actions/challenge-actions';
import Loading from '../../shared/Loading'

import ChallengeContext from '../../../context/challenge-context'
import { challengeReducer, initialState } from '../../../reducers/challenge-reducer'
import { getIconChallenge } from '../../../utils/helpers/icon/iconHelper';
import { DefaultLayout} from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import TeamMember from './TeamMember'
import Leaderboard from './Leaderboard'
import Activities from './Activities'
import ChallengeOverview from './ChallengeOverview'
import SignUpDialog from './SignUpDialog'
import { ConvertDateString } from '../../../utils/helpers/dateformat/ConvertDateString'

function init() {
    return {
        loading: true,
        challenge: {},
        onGoingChallenges: [],
        closeChallenges: [],
        tabs: {
            teamMember: false,
            overview: true,
            leaderboard: false,
            activities: false,
        },
        dialogs: {
            signUpDialog: false,
        },
        signUpForm: {
            challengeId: 0,
            teamName: '',
            teamMembers: [
                {
                    studentNumber: '',
                    isLeader: false
                },
                {
                    studentNumber: '',
                    isLeader: false
                },
                {
                    studentNumber: '',
                    isLeader: false
                }
            ]
        },
        alert: {
            severity: '', //error,warning,info,success
            message: ''
        },
        signUpLoading: false,
        signUpResult: {
            isError: false,
            message: '',
        },
        reLoadContent: false,
    };
}

const ChallengeDetail = () => {

    const classes = useStyles();
    let { id } = useParams();
    const history = useHistory();
    const [challengeContext, dispatch] = useReducer(challengeReducer, initialState, init);

    useEffect(() => {
        initChallengeDetail();
    }, [challengeContext.reLoadContent]);

    const initChallengeDetail = async () => {
        const response = await getChallengeById(id);

        if (response > 200 || response.status === "Failed") {
            dispatch({ type: 'SET_LOADING', loading: false });
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {
            let challenge = response.data;
            let today = new Date();
            let endDate = new Date(ConvertDateString.convertForDatePicker(challenge.EndDate));
            if (today > endDate)
                challenge.IsEnded = true;
            else
                challenge.IsEnded = false;

            dispatch({ type: 'SET_CHALLENGE', challenge: challenge });
            dispatch({ type: 'SET_LOADING', loading: false });
        }

    };

    const handleClickTabs = (item) => {

        switch (item) {
            case "overview":
                challengeContext.tabs.overview = true;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "teamMember":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = true;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "activities":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = true;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "leaderboard":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = true;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
        }
    }

    if (challengeContext.loading) return <Loading />;

    return (
        <ChallengeContext.Provider value={{ challengeContext, dispatch }}>
            <DefaultLayout
                title={challengeContext.challenge.ChallengeTitle}
                type='Challenge'
                description={`From ${challengeContext.challenge.StartDate} -> To ${challengeContext.challenge.EndDate}`}
                image={getIconChallenge().img_challenge_bg}
            >
                <Grid container>
                    <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} >
                        <Hidden mdDown>
                            <Grid
                                classes={{ root: classes.rootWrapperTab }}
                                className={clsx(challengeContext.tabs.overview && classes.rootWrapperTabActive)}
                                container
                                justify="flex-end"
                                onClick={() => handleClickTabs("overview")}>
                                <Grid
                                    container
                                    item
                                    lg={12} xl={10}
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridTab }}
                                >
                                    <div className={classes.containerImage}>
                                        <img src="/assets/images/components/challenge/challengeBG.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                    </div>
                                    <div className={classes.containerContent}>
                                        Challenge Overview
                                </div>
                                </Grid>
                            </Grid>
                            <Grid
                                classes={{ root: classes.rootWrapperTab }}
                                className={clsx(challengeContext.tabs.teamMember && classes.rootWrapperTabActive)}
                                container
                                justify="flex-end"
                                onClick={() => handleClickTabs("teamMember")}>
                                <Grid
                                    container
                                    item
                                    lg={12} xl={10}
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridTab }}
                                >
                                    <div className={classes.containerImage}>
                                        <img src="/assets/images/components/challenge/team.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                    </div>
                                    <div className={classes.containerContent}>
                                        Team Members
                                </div>
                                </Grid>
                            </Grid>
                            {
                                challengeContext.challenge.IsEnded ?
                                    <></>
                                    :
                                    <Grid
                                        classes={{ root: classes.rootWrapperTab }}
                                        className={clsx(challengeContext.tabs.activities && classes.rootWrapperTabActive)}
                                        container
                                        justify="flex-end"
                                        onClick={() => handleClickTabs("activities")}>
                                        <Grid
                                            container
                                            item
                                            lg={12} xl={10}
                                            justify="center"
                                            alignItems="center"
                                            classes={{ root: classes.rootGridTab }}
                                        >
                                            <div className={classes.containerImage}>
                                                <img src="/assets/images/components/challenge/activity.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                            </div>
                                            <div className={classes.containerContent}>
                                                Activities
                                </div>
                                        </Grid>
                                    </Grid>
                            }
                            <Grid
                                classes={{ root: classes.rootWrapperTab }}
                                className={clsx(challengeContext.tabs.leaderboard && classes.rootWrapperTabActive)}
                                container
                                justify="flex-end"
                                onClick={() => handleClickTabs("leaderboard")}>
                                <Grid
                                    container
                                    item
                                    lg={12} xl={10}
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridTab }}
                                >
                                    <div className={classes.containerImage}>
                                        <img src="/assets/images/components/challenge/leaderboard.jpg" style={{ borderRadius: '10px 0px 0px 10px' }} />
                                    </div>
                                    <div className={classes.containerContent}>
                                        Leaderboard
                                </div>
                                </Grid>
                            </Grid>
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} md={9} classes={{ root: classes.rootGridContentContainer }}>
                        {
                            challengeContext.tabs.overview ? <ChallengeOverview /> : <></>
                        }
                        {
                            challengeContext.tabs.teamMember ? <TeamMember /> : <></>
                        }
                        {
                            challengeContext.tabs.activities ? <Activities /> : <></>
                        }
                        {
                            challengeContext.tabs.leaderboard ? <Leaderboard /> : <></>
                        }
                    </Grid>
                </Grid>
                <SignUpDialog />
            </DefaultLayout>
        </ChallengeContext.Provider >
    );
};

export default ChallengeDetail;